var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSyusd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 125,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.822 182.812V203.089H118.178V181.861C96.6337 178.693 80.7921 166.02 79.5247 148.594H101.386C103.604 158.733 115.644 165.069 130.851 165.069C145.109 165.069 155.248 159.049 155.248 150.812C155.248 125.782 80.7921 151.129 80.7921 102.97C80.7921 86.495 96.3168 75.4059 118.178 73.5049V52.5941H137.822V73.8218C159.049 76.9901 173.307 89.0297 174.891 105.188H153.03C151.129 96.9505 140.04 90.297 126.416 90.297C111.525 90.297 102.02 96 102.02 103.287C102.02 126.733 176.475 102.337 176.475 151.129C176.475 167.604 162.218 180.911 137.822 182.812ZM128 256C57.3465 256 0 198.653 0 128C0 57.3465 57.3465 0 128 0C198.653 0 256 57.3465 256 128C256 198.653 198.653 256 128 256ZM128 13.9406C64.9505 13.9406 13.9406 64.9505 13.9406 128C13.9406 191.049 65.2673 242.059 128 242.059C190.733 242.059 242.059 190.733 242.059 128C242.059 64.9505 191.049 13.9406 128 13.9406Z",
    fill: "#15171A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSyusd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/syusd.08198064f311a50f19229a2817376ed6.svg";